import { is } from 'cypress/types/bluebird'
import { Helper } from '../../../../../classes/helper'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'

interface Props {
  offset: number
}
export const DynamicBar = ({ offset }: Props): JSX.Element => {
  const {
    attachment,
    userWidth,
    verandaTyp,
    userAngle,
    roofLogWidth,
    isQubus,
  } = useMeasures()

  const { color } = useRoof()

  return (
    <mesh
      castShadow={true}
      position={[
        0,
        isQubus
          ? -verandaTyp.roofBar.width / 2
          : verandaTyp.roofBar.width / 2 + offset / 2,
        roofLogWidth / 2 -
          (attachment.free ? 0 : 0) +
          (isQubus ? verandaTyp.log.width / 2 : 0),
      ]}
      rotation={[
        Helper.convertAngleToRadiant(userAngle!),
        Helper.convertAngleToRadiant(90),
        0,
      ]}
    >
      <boxGeometry
        args={[
          verandaTyp.roofBar.depth,
          verandaTyp.roofBar.width,
          userWidth - verandaTyp.roofBar.depth * 2,
        ]}
      />
      <CachedMeshPhysicalMaterial color={color} metalness={0.9} />
    </mesh>
  )
}
